<script setup>
import ReportHeader from './ReportHeader.vue';
import V4Button from 'dashboard/components-next/button/Button.vue';
import { useSummaryReportDownload } from '../composables/useSummaryReportDownload';

const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  reportType: {
    type: String,
    required: true,
    validator: value => ['agent', 'team', 'inbox', 'label'].includes(value),
  },
  filters: {
    type: Object,
    required: true,
  },
  downloadLabel: {
    type: String,
    required: true,
  },
  showBackButton: {
    type: Boolean,
    default: true,
  },
  showDownload: {
    type: Boolean,
    default: true,
  },
});

const { downloadReports } = useSummaryReportDownload(
  props.reportType,
  () => props.filters
);
</script>

<template>
  <ReportHeader :header-title="title" :has-back-button="showBackButton">
    <div class="flex flex-wrap items-center gap-2">
      <slot />
      <V4Button
        v-if="showDownload"
        :label="downloadLabel"
        icon="i-ph-file-arrow-down"
        size="sm"
        @click="downloadReports"
      />
    </div>
  </ReportHeader>
</template>
